import { TotalCard, TotalCardIcon, TotalCardLabel, TotalCardNumber, TotalCardRow, TotalCards, TotalCardsContainer, TotalCardsTitle, TotalCardSubTitle, TotalCardTitle, TotalCardWrapper } from "./Components"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUsersBetweenLines, faEye, faChartPie } from '@fortawesome/free-solid-svg-icons';
import { useCallback, useEffect, useRef, useState } from "react";
import ReportsService from "../../services/reports.service";
import { DataLoading } from "../../components/PreLoader/PreLoader";
import Skeleton from "../../components/PreLoader/Skeleton";
import { TimeDisplay } from "../../components/General/TimeDisplay";
import { ByteDisplay } from "../../components/General/ByteDisplay";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../../services/constants";
export const DashboardTotalCards = () => {
    const [reportData, setReportData] = useState(null)
    const reloadTimeoutRef = useRef(null);
    const fetchData = useCallback(async () => {
        const dataFetched = await ReportsService.dashboardCounter();
        setReportData(dataFetched)
    }, []);
    useEffect(() => {
        fetchData();
        reloadTimeoutRef.current = setInterval(() => {
            console.log("reload data")
            fetchData();
        }, 10000)
        return () => {
            if(reloadTimeoutRef.current) clearInterval(reloadTimeoutRef.current)
        }
    }, [])
    
    return (
        <TotalCardsContainer>
            <TotalCardsTitle>Dashboard Report</TotalCardsTitle>
            <TotalCards>
                <TotalCard>
                    <TotalCardWrapper>
                        <TotalCardTitle>Members</TotalCardTitle>
                        <TotalCardSubTitle>(Total members reports)</TotalCardSubTitle>
                        {!reportData?(
                            <>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                            </>
                        ):(
                            <>
                                <TotalCardRow>
                                    <TotalCardLabel>Total registered members: </TotalCardLabel>
                                    <TotalCardNumber>{!reportData?<Skeleton height={20} />:(<NavLink to={ROUTES.ALL_USERS}>{`${reportData?.total_members}`}</NavLink>)}</TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel>Total paid members: </TotalCardLabel>
                                    <TotalCardNumber>{!reportData?<Skeleton height={20} />:(<NavLink to={ROUTES.ALL_USERS.concat('?subscription=active')}>{`${reportData?.total_active_members}`}</NavLink>)}</TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel>Total online now: </TotalCardLabel>
                                    <TotalCardNumber>{!reportData?<Skeleton height={20} />:(<NavLink to={ROUTES.ALL_USERS.concat('?online=true')}>{`${reportData?.total_online_members}`}</NavLink>)}</TotalCardNumber>
                                </TotalCardRow>
                            </>
                        )}
                        
                    </TotalCardWrapper>
                </TotalCard>
                <TotalCard>
                    <TotalCardWrapper>
                        <TotalCardTitle>Channel Breakdown</TotalCardTitle>
                        <TotalCardSubTitle>(Current Online Users)</TotalCardSubTitle>
                        {!reportData?(
                            <>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                            </>
                        ):(
                            reportData?.channels_online.map((channel, index) => {
                                return (
                                    <TotalCardRow>
                                        <TotalCardLabel>{channel?.name}: </TotalCardLabel>
                                        <TotalCardNumber>{`${channel?.online}`}</TotalCardNumber>
                                    </TotalCardRow>
                                )
                            })
                        )}
                        
                    </TotalCardWrapper>
                </TotalCard>
                <TotalCard>
                    <TotalCardWrapper>
                        <TotalCardTitle>Engagement</TotalCardTitle>
                        <TotalCardSubTitle>(Time Watched / Listened)</TotalCardSubTitle>
                        {!reportData?(
                            <>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                            </>
                        ):(
                            reportData?.channels_engagement.map((channel, index) => {
                                return (
                                    <TotalCardRow>
                                        <TotalCardLabel>{channel?.name}: </TotalCardLabel>
                                        <TotalCardNumber><TimeDisplay seconds={channel?.watched} /></TotalCardNumber>
                                    </TotalCardRow>
                                )
                            })
                        )}
                        
                    </TotalCardWrapper>
                </TotalCard>
                <TotalCard>
                    <TotalCardWrapper>
                        <TotalCardTitle>Usage Data</TotalCardTitle>
                        <TotalCardSubTitle>(Bandwidth using)</TotalCardSubTitle>
                        {!reportData?(
                            <>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                                <TotalCardRow>
                                    <TotalCardLabel><Skeleton height={20} /></TotalCardLabel>
                                    <TotalCardNumber><Skeleton height={20} /></TotalCardNumber>
                                </TotalCardRow>
                            </>
                        ):(
                            reportData?.channels_engagement.map((channel, index) => {
                                return (
                                    <TotalCardRow>
                                        <TotalCardLabel>{channel?.name}: </TotalCardLabel>
                                        <TotalCardNumber><ByteDisplay bytes={channel?.bytes} /></TotalCardNumber>
                                    </TotalCardRow>
                                )
                            })
                        )}
                        
                    </TotalCardWrapper>
                </TotalCard>
            </TotalCards>
        </TotalCardsContainer>   
    )
}